import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthModal } from '../../hooks/useAuthModal';
import { hrefFor } from '../../routers';
import { useFavorites, UseFavoritesProps } from './';

export const useFavorite = ({ variant }: UseFavoritesProps) => {
  const location = useLocation();
  const { user, handleFavorite, isFavorited } = useFavorites({ variant });
  const { openAuthModal } = useAuthModal();

  const [showConfirmRemove, setShowConfirmRemove] = useState(false);

  const label = isFavorited ? 'Remove from Favorites' : 'Add to Favorites';

  const onClick = useCallback(() => {
    if (!showConfirmRemove && isFavorited && location.pathname === hrefFor.FavoritesPage()) {
      setShowConfirmRemove(true);
    } else if (user.isLoggedIn) {
      handleFavorite();
      setShowConfirmRemove(false);
    } else {
      openAuthModal({ onSuccess: handleFavorite });
    }
  }, [
    handleFavorite,
    isFavorited,
    location.pathname,
    openAuthModal,
    showConfirmRemove,
    user.isLoggedIn
  ]);
  const onCloseConfirm = useCallback(() => setShowConfirmRemove(false), [setShowConfirmRemove]);

  return { label, onClick, onCloseConfirm, isFavorited, showConfirmRemove };
};
